import tinymce from "tinymce/tinymce";

export const clearUndo = () => {
  tinymce.activeEditor.undoManager.clear();
}

export const resetTextEditor = (editorID) => {
  tinymce.EditorManager.execCommand('mceRemoveControl', false, editorID);
  tinymce.EditorManager.execCommand('mceAddControl', false, editorID);
}